import { render, staticRenderFns } from "./UserProfileViewOverview.vue?vue&type=template&id=05026bad&"
import script from "./UserProfileViewOverview.vue?vue&type=script&lang=js&"
export * from "./UserProfileViewOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports